import styled from 'styled-components';

import { CardStyledType } from './types';

export const StyledCardOption = styled.div<CardStyledType>`
    width: 100%;
    position: relative;
    max-height: 180px;
    ${({ maxWidth }) => maxWidth && `max-width: ${maxWidth}px;`}
`;

export const StyledCardButton = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    width: 100%;
    bottom: 0;
    z-index: 2;
    flex-wrap: nowrap;
    border-radius: 100px;
    padding: 12px 16px;
    background-color: ${({ theme }) => theme['primary-default']};
    color: red;
    min-height: 44px;
`;

export const Icon = styled.img`
    margin-left: 13px;
`;
